import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { alpha, useTheme } from "@mui/material/styles";
import MDBox from "components/MDBox";
import type { PedidoOperacionalInput } from "interfaces/loja/pedidoOperacional";
import { getProximaEtapa } from "utils/pedidoOperacional";

type PedidoProximaEtapaCardProps = {
  input: PedidoOperacionalInput;
};

export default function PedidoProximaEtapaCard({
  input,
}: PedidoProximaEtapaCardProps) {
  const proxima = getProximaEtapa(input);
  const theme = useTheme();
  const mode = theme.palette.mode;
  const borderSoft =
    mode === "dark" ? alpha("#c8e6c9", 0.45) : alpha("#7cb342", 0.22);

  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: 2,
        border: `1px solid ${borderSoft}`,
        boxShadow: "0 2px 12px rgba(0,0,0,0.04)",
        height: "100%",
      }}
    >
      <MDBox p={2.5}>
        <Stack spacing={1.5}>
          <Typography variant="button" fontWeight={700} color="primary">
            Próxima etapa
          </Typography>
          <Typography variant="h6" fontWeight={700}>
            {proxima.titulo}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {proxima.descricao}
          </Typography>
          <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
            Use o bloco &quot;Continuar fluxo&quot; acima para ir à etapa
            indicada.
          </Typography>
        </Stack>
      </MDBox>
    </Card>
  );
}
